import {updateProduct} from './../../../scripts/helpers/cart'

export default class CartItem {
  constructor(component) {
    this.dom = {
      $component: component,
      $removeBtn: component.querySelector('.js-itemRemove'),
      $qtySelectorMinus: component.querySelector('.js-qtySelectorMinus'),
      $qtySelectorPlus: component.querySelector('.js-qtySelectorPlus')
    }
    this.state = {
      variantId: parseInt(component.dataset.variantId),
      quantity: parseInt(component.dataset.qtyValue)
    }
    this.removeProductHandler = this.removeProduct.bind(this)
    this.minusProductHandler = this.minusProduct.bind(this)
    this.plusProductHandler = this.plusProduct.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$removeBtn.addEventListener('click', this.removeProductHandler)
    if (dom.$qtySelectorMinus) dom.$qtySelectorMinus.addEventListener('click', this.minusProductHandler)
    if (dom.$qtySelectorPlus) dom.$qtySelectorPlus.addEventListener('click', this.plusProductHandler)
  }

  async removeProduct() {
    const {state} = this
    const newQty = updateProduct(state.variantId, 0)
    state.quantity = newQty
  }

  async minusProduct() {
    const {state} = this
    const newQty = await updateProduct(state.variantId, state.quantity - 1)
    state.quantity = newQty
  }

  async plusProduct() {
    const {state} = this
    const newQty = await updateProduct(state.variantId, state.quantity + 1)
    state.quantity = newQty
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.CartItem = this
  }
}
